import moment from "moment/moment";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";

export const dataListMonth = () => {
    return [
        {
            title: "28 ngày trước",
            startDate: moment().subtract(28, "days"),
            endDate: moment().subtract(1, "days"),
            key: KeyConstant.THIRTY_DAYS_AGO
        },
        {
            title: "90 ngày trước",
            startDate: moment().subtract(90, "days"),
            endDate: moment().subtract(1, "days"),
            key: KeyConstant.NINETY_DAYS_AGO
        },
        {
            title: "Tháng này",
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
            key: KeyConstant.THIS_MONTH
        },
        {
            title: "Tháng trước",
            startDate: moment().subtract(1, "months").startOf("month"),
            endDate: moment().subtract(1, "months").endOf("month"),
            key: KeyConstant.LAST_MONTH
        }
    ]
}
